import { useTranslation } from 'next-i18next';
import { useCandidateProfile } from 'lib/contexts/candidate-profile-context';
import { useAuth } from 'lib/providers/AuthProvider';
import { CHROME_EXTENSION_STORE_LINK } from 'utils/urls';

import styles from './ChromeExtensionWidget.module.scss';

export const ChromeExtensionWidget = () => {
  const { basicInfoComplete, educationComplete, experienceComplete } =
    useCandidateProfile();
  const { candidate } = useAuth();
  const { extension_installed } = candidate || {};
  const [t] = useTranslation('candidate.profile');

  return (
    <>
      {basicInfoComplete &&
        educationComplete &&
        experienceComplete &&
        !extension_installed && (
          <section className={styles.container}>
            <p className={styles.text}>
              {t('chrome-extension-widget.info1')}
              <span
                className={styles.link}
                onClick={() => {
                  window.open(CHROME_EXTENSION_STORE_LINK, '_blank');
                }}
              >
                {t('chrome-extension-widget.link')}
              </span>{' '}
              {t('chrome-extension-widget.info2')}
            </p>
          </section>
        )}
    </>
  );
};
